import { Currency } from "./currency";
import { i18n } from "@lingui/core";

export const formatI18nCurrency = (
  value: number,
  currency: Currency | undefined
): string =>
  i18n.number(value, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
